import { CalendarMonth, Group } from '@mui/icons-material';
import { Box, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { AwaitButton } from '../../../../reusable-components/await-button';
import CloseIconButton from '../../../../reusable-components/basic-buttons/CloseIconButton';
import { fDateMonth } from '../../../../utils/formatTime';

CensusConfirmModal.propTypes = {
  open: PropTypes.bool,
  updatedCensus: PropTypes.array,
  setOpen: PropTypes.func,
  updateData: PropTypes.func,
  facilities: PropTypes.object,
  loading: PropTypes.bool,
  updateDefault: PropTypes.bool,
  setUpdateDefault: PropTypes.func,
};

export default function CensusConfirmModal({
  loading, updateData,
  open, setOpen,
  updatedCensus, facilities,
  updateDefault, setUpdateDefault
}) {

  const handleUpdate = () => {
    updateData();
    handleClose();
  };

  const handleClose = () => {
    setUpdateDefault(false);
    setOpen(false);
  };

  return <Dialog open={open} onClose={(event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    handleClose();
  }} maxWidth="sm" fullWidth>
    <DialogTitle sx={{ textAlign: 'center' }}>
      <Box sx={{ pr: 2, color: "info.main" }}>
        Updated Census for {Object.values(facilities ?? []).join(", ")}
      </Box>
      <CloseIconButton onClick={handleClose} sx={{
        position: 'absolute',
        right: 8,
        top: 8
      }} />  </DialogTitle>
    <DialogContent sx={{ height: '100%', width: '100%' }}>
      {!!updatedCensus.length &&
        <Grid container sx={{ mt: 1, gap: 2 }} justifyContent={updatedCensus.length === 1 ? "center" : "flex-start"}>
          {updatedCensus?.map(c =>
            <Grid item
              xs={(updatedCensus.length === 1 ? 'auto' : 5.8)}
              key={c.date}
              sx={{ border: "black 1px solid", borderColor: (theme) => theme.palette.grey[600], borderRadius: 2, p: 2 }}>
                <Typography>
                <Group sx={{ fontSize: 16, color: "info.main", mr: 1 }} />
                Facility: {facilities[c.facilityId] ?? ''}
              </Typography>
              <Typography>
                <CalendarMonth sx={{ fontSize: 16, color: "info.main", mr: 1 }} />
                Date: {updateDefault ? `${fDateMonth(new Date(Date.now() - 30 * (24 * 60 * 60 * 1000)))} - ${fDateMonth(new Date())}` : fDateMonth(c.date)}
              </Typography>
              <Typography>
                <Group sx={{ fontSize: 16, color: "info.main", mr: 1 }} />
                Census: {c.number}
              </Typography>
              {updatedCensus.length === 1 &&
                <Typography>
                  <Checkbox color="info" size="small"
                    sx={{ p: 0, ml: -0.3, mr: 0.5 }}
                    checked={updateDefault} onChange={() => setUpdateDefault(checked => !checked)} /> Set as default census
                </Typography>}
            </Grid>
          )}
        </Grid>
      }
    </DialogContent>
    <DialogActions>
      <AwaitButton variant="contained" color="primary" size="small" sx={{ width: 150 }}
        onClick={handleUpdate} loading={loading}>
        Update census
      </AwaitButton>
    </DialogActions>
  </Dialog>
}
